module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-4-Lets-Talk-About-Something-Else-80bb53caa9ae606757b684bf84b34194.pdf";